
import Vue, { PropType } from 'vue';
import {
  Item, Link, Wrapper,
} from './styles';
import { MenuItem } from '../../config/types';

export default Vue.extend({
  name: 'Dropdown',
  components: {
    Item,
    Link,
    Wrapper,
  },
  props: {
    menuList: {
      type: Array as PropType<Array<MenuItem>>,
      default: [] as PropType<Array<MenuItem>>,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
});
